export class ReturnForCredit {

    constructor() {
        this._refs = {
            orderlinesvalue: document.querySelector('[data-orderlines]'),
            serialnumbersvalue: document.querySelector('[data-serialnumbers]'),
            orderlinescheckboxes: document.querySelectorAll('.return_items__product_list-item input[type="checkbox"]'),
            totalorderlines: document.querySelector('.return_total-orderlines'),
            totalselected: document.querySelector('.return_total-selected'),
            submitbutton: document.querySelector('.submitorderbutton'),
            //to be changed in fututre - needs an id or some unique indentifier from BE in order to be done, all the return* should be done with some unique id
            returndd: document.querySelector('.configurator__dropdown .form-select select'),
            returncheckbox: document.querySelector('.return_reason__issue .configuratorcheckbox'),
            returncomment: document.querySelector('.return_reason__issue textarea'),
            deselectlines: document.querySelector('.return_reason__deselect'),
            dialoglink: document.querySelectorAll('.configurator-open-dialog'),
            availableCheckboxes: document.querySelectorAll('.return_items__product_list-item input[type="checkbox"]:not(:disabled)'),
            categoriesOptions: document.querySelectorAll('[data-id="MultiselectOption"]'),
            returnReasonsContainer: document.querySelector('.configurator__multiselect-wrapper'),
            reasonOptions: null,
            pimSettings: {
                url: `${window.location.origin}/api/pim/getColorImageAssets`,
                filetype: 'psd'
            },
            trashIcons: null,
            selectedDropDownOption: null,
            shownOptionsCount: document.querySelectorAll('.shownOptionsCount')
        }
        this._refs.orderlinescheckboxes.forEach(x => x.addEventListener('change', this._orderlineCheckboxChange.bind(this)));
        if (this._refs.returndd)
            this._refs.returndd.addEventListener('change', this._returnReasonChange.bind(this));

        this._refs.deselectlines.addEventListener('click', this._selectDeselectAllOrderlines.bind(this));
        this._refs.dialoglink.forEach(x => x.addEventListener('click', this._openDialogSerialNumbers.bind(this)));
        if (this._refs.returncheckbox)
            this._refs.returncheckbox.addEventListener('change', this._devicesSealedChange.bind(this));
        if (this._refs.returncomment)
            this._refs.returncomment.addEventListener('blur', this._addComment.bind(this));
        if (this._refs.returnReasonsContainer)
            this._refs.returnReasonsContainer?.addEventListener('click', this._updateReturnReasons.bind(this));
        this._refs.categoriesOptions.forEach(x => x.addEventListener('click', this._disableEnableSubmit.bind(this)));
        this._refs.shownOptionsCount.forEach(x => x.innerText = '(0)');
        this._init();
    }

    async _init() {
        this._setInitialValues();
    }

    _orderlineCheckboxChange(e) {
        if (e.srcElement.checked) {
            this._refs.orderlinesvalue.innerText = parseFloat(this._refs.orderlinesvalue.innerText) + 1;
            this._refs.serialnumbersvalue.innerText = parseFloat(this._refs.serialnumbersvalue.innerText) + parseFloat(e.target.parentElement.dataset.serialnumberscount);
            this._refs.totalselected.innerText = parseFloat(this._refs.totalselected.innerText) + 1;
            if (this._refs.totalselected.innerText == this._refs.availableCheckboxes.length) {
                this._refs.deselectlines.dataset.deselect = "true";
            }
        }
        else {
            this._refs.orderlinesvalue.innerText = parseFloat(this._refs.orderlinesvalue.innerText) - 1;
            this._refs.serialnumbersvalue.innerText = parseFloat(this._refs.serialnumbersvalue.innerText) - parseFloat(e.target.parentElement.dataset.serialnumberscount);
            this._refs.totalselected.innerText = parseFloat(this._refs.totalselected.innerText) - 1;
            if (parseFloat(this._refs.totalselected.innerText) == 0) {
                this._refs.deselectlines.dataset.deselect = "false";
            }
        }
        this._disableEnableSubmit();
    }

    _setInitialValues() {
        const totalChecked = Array.from(this._refs.orderlinescheckboxes).filter(i => i.checked);
        this._refs.totalorderlines.innerText = this._refs.orderlinescheckboxes.length;
        this._refs.totalselected.innerText = totalChecked.length;
        this._refs.orderlinesvalue.innerText = this._refs.totalselected.innerText;
        this._refs.serialnumbersvalue.innerText = totalChecked.reduce((acc, itemsChekced) => acc + parseFloat(itemsChekced.parentElement.dataset.serialnumberscount), 0);
        this._disableEnableSubmit();
    }

    _returnReasonChange() {
        const selectedDropDownOption = (this._refs.returndd).options[(this._refs.returndd).selectedIndex];
        const returnReasonDropDownValue = selectedDropDownOption.innerHTML;
        const selectedOptionHasValue = selectedDropDownOption.value; //to avoid passing "Selected" as a return reason in summary
        const htmlElement = document.querySelector('.return-for-credit_summary-details .return_info-select');
        const reasonsLabel = document.querySelector('.return_reason__title').innerHTML;
        this._refs.selectedDropDownOption = selectedDropDownOption;
        if (returnReasonDropDownValue && selectedOptionHasValue) {
            htmlElement.innerHTML = this._returnReasonDetailsTemplate(reasonsLabel, returnReasonDropDownValue);
            htmlElement.classList.remove('hiddenInfo');
        }
        else {
            htmlElement.innerHTML = '';
            htmlElement.classList.add('hiddenInfo');
        }
        this._disableEnableSubmit();
    }

    _returnReasonDetailsTemplate(title, text) {
        return `
            <div class="configurator_info__title">${title}</div>
            <div class="configurator_info__value">${text}</div>
        `;
    }

    _devicesSealedChange() {
        const htmlElement = document.querySelector('.return-for-credit_summary-details .return_info-checkbox');
        if (this._refs.returncheckbox.querySelector('input').checked) {
            const devicesLabel = this._refs.returncheckbox.querySelector('label').innerText;
            const devicesValue = document.querySelector('#YesLabel').value;
            htmlElement.innerHTML = this._returnReasonDetailsTemplate(devicesLabel, devicesValue);
            htmlElement.classList.remove('hiddenInfo');
        }
        else {
            htmlElement.innerHTML = '';
            htmlElement.classList.add('hiddenInfo');
        }

    }

    _addComment() {
        const htmlElement = document.querySelector('.return-for-credit_summary-details .return_info-textarea');
        const commentValue = this._refs.returncomment.value;
        if (commentValue) {
            const commentLabel = this._refs.returncomment.labels[0].innerText;
            htmlElement.innerHTML = this._returnReasonDetailsTemplate(commentLabel, commentValue);
            htmlElement.classList.remove('hiddenInfo');
        }
        else {
            htmlElement.innerHTML = '';
            htmlElement.classList.add('hiddenInfo');
        }

    }

    _updateReturnReasons() {
        const htmlElement = document.querySelector('.return-for-credit_summary-details .return_info-textarea');
        setTimeout(() => {
            const reasonOptions = this._refs.reasonOptions;
            if (reasonOptions) {
                const reasonsLabel = document.querySelector('.return_reason__title').innerHTML;
                let reasonValues = '';
                reasonOptions.forEach((reason, index) => {
                    const separator = index > 0 ? ', ' : ''
                    reasonValues = `${reasonValues}${separator}${reason.innerText}`
                })
                htmlElement.innerHTML = this._returnReasonDetailsTemplate(reasonsLabel, reasonValues);
            }
            else {
                htmlElement.innerHTML = '';
            }
            this._refs.trashIcons = document.querySelectorAll('.eva-trash-2-outline');
            this._refs.trashIcons.forEach(x => x.addEventListener('click', this._handleTrashClick.bind(this)))
        }, 0);
    }

    _disableEnableSubmit() {
        const isOrderlineCheckboxChecked = parseFloat(this._refs.orderlinesvalue.innerText) > 0;
        const selectedDropDownOption = this._refs.selectedDropDownOption;
        setTimeout(() => {
            this._refs.reasonOptions = document.querySelectorAll('.configurator__multiselect-chosenoptions_option');
            const returnReasonDropDownValue = selectedDropDownOption?.innerHTML;
            const selectedOptionHasValue = selectedDropDownOption?.value; //to avoid passing "Selected" as a return reason in summary
            const isReasonOptionChosen = Boolean(this._refs.reasonOptions?.length);
            const shouldBeEnabled = (isOrderlineCheckboxChecked && isReasonOptionChosen) || (isOrderlineCheckboxChecked && returnReasonDropDownValue && selectedOptionHasValue);
            this._refs.submitbutton.disabled = !shouldBeEnabled;
        }, 0)
    }

    _handleTrashClick() {
        this._disableEnableSubmit();
    }

    _selectDeselectAllOrderlines() {
        if (this._refs.deselectlines.dataset.deselect == "true") {
            (this._refs.orderlinescheckboxes).forEach(el => el.checked = false);
            this._refs.deselectlines.dataset.deselect = "false";
            this._refs.totalselected.innerText = 0;
            this._refs.orderlinesvalue.innerText = 0;
            this._refs.serialnumbersvalue.innerText = 0;
            this._disableEnableSubmit();
        }
        else {
            const orderLinesSelected = this._refs.availableCheckboxes.length;
            const serialNumbersSelected = (Array.from(this._refs.orderlinescheckboxes)).reduce((acc, itemsChekced) => acc + parseFloat(itemsChekced.parentElement.dataset.serialnumberscount), 0);
            (this._refs.availableCheckboxes).forEach(el => el.checked = true);
            this._refs.deselectlines.dataset.deselect = "true";
            this._refs.totalselected.innerText = orderLinesSelected;
            this._refs.orderlinesvalue.innerText = orderLinesSelected;
            this._refs.serialnumbersvalue.innerText = serialNumbersSelected;
            this._disableEnableSubmit();
        }
    }

    _openDialogSerialNumbers(e) {
        const title = e.target.dataset.overlaytitle;
        const text = e.target.dataset.overlaytext;
        const serialnum = (e.target.dataset.dialognumbers).split(',');
        let counter = 1;
        const serialnumTemplate = serialnum.map(function (serial) {
            return '<li><span class="dialog-serialnumbers__list-counter">' + counter++ + '.</span><span class="dialog-serialnumbers__list-number">' + serial + '</span></li>';
        }).join('');
        const template = `
        <dialog id="dialogSerailsNumbers" class="dialog-serialnumbers">
                <button class="dialog-close" type="reset"><i class="eva eva-close-outline"></i></button>
                <div class="bold-font">${title}</div>
                <div class="dialog-scrollable">
                    <ul class="dialog-serialnumbers__list">
                    ${serialnumTemplate}
                    </ul>
                </div>
         </dialog>
        `;
        e.srcElement.insertAdjacentHTML('afterend', template);
        const dialogElement = document.querySelector('.dialog-serialnumbers');
        if (typeof dialogElement.showModal === "function") {
            dialogElement.showModal();
        } else {
            outputBox.value = "Sorry, the <dialog> API is not supported by this browser.";
        }
        document.querySelector('.dialog-close').addEventListener("click", () => {
            dialogElement.remove();
        })
        dialogElement.addEventListener('click', (ev) => {
            if (ev.offsetX < 0 || ev.offsetX > ev.target.offsetWidth ||
                ev.offsetY < 0 || ev.offsetY > ev.target.offsetHeight) {
                dialogElement.remove();
            }
        });
    }

}
